module.exports = __webpack_public_path__ + "media/images/img02-ce88e60aa7bcc438ff330f7bf105ac6c.png";